export { ContactContent } from './ContactContent';
export type { ContactContentProps, ContactInfo } from './ContactContent';